module.exports = __webpack_public_path__ + "media/images/lb/256-5948df68506642bdb8e9d5aa39533998.svg";